// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__OiFkG","button_white":"style_button_white__1aC-t"};